import { Box, Link, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { OV2 } from './ordering-v2-tokens';

// ----------------------------------------------------------------------

const linkSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  color: OV2.textSecondary,
  fontSize: 13,
  letterSpacing: '0.01em',
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': { color: OV2.primary },
};

const contentPad = { xs: 2, sm: 2.5, md: 3.5, lg: 4 };

export default function OrderingUtilityBar() {
  return (
    <Box
      component="nav"
      aria-label="Utility"
      sx={{
        height: OV2.utilityBarHeight,
        bgcolor: OV2.bgLight,
        borderBottom: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          maxWidth: OV2.contentMaxWidth,
          mx: 'auto',
          px: contentPad,
          width: 1,
          height: 1,
        }}
      >
      <Stack direction="row" alignItems="center" spacing={3}>
        <Link href="#" onClick={(e) => e.preventDefault()} sx={linkSx} underline="none">
          <Iconify icon="mdi:earth" width={16} />
          Language
        </Link>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={3} sx={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <Stack direction="row" alignItems="center" spacing={0.75} sx={{ ...linkSx, cursor: 'default', '&:hover': { color: OV2.textSecondary } }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: '#ff0000',
              animation: 'ov2Pulse 2s ease-in-out infinite',
              '@keyframes ov2Pulse': {
                '0%, 100%': { opacity: 1 },
                '50%': { opacity: 0.45 },
              },
            }}
          />
          <Typography component="span" variant="inherit" sx={{ fontSize: 'inherit', color: 'inherit' }}>
            Live
          </Typography>
        </Stack>
        <Link href="#" onClick={(e) => e.preventDefault()} sx={linkSx} underline="none">
          Store info
        </Link>
        <Link href="#" onClick={(e) => e.preventDefault()} sx={linkSx} underline="none">
          Careers
        </Link>
        <Link href="#" onClick={(e) => e.preventDefault()} sx={linkSx} underline="none">
          Franchise
        </Link>
      </Stack>
      </Stack>
    </Box>
  );
}
